import type { Procedure, ProcedureFetchParams } from '@epihub/core/src/procedure';
import { createPathname } from '@epihub/core/src/procedure';
import type { DeepPartial } from '@epihub/core/src/ts';

export function buildProcedureKey<Def extends Procedure>(
  procedure: Def,
  payloadOrSkip: DeepPartial<ProcedureFetchParams<Def>['params']>,
) {
  if (!payloadOrSkip) {
    return [];
  }

  const pathname = createPathname(procedure, payloadOrSkip);
  return pathname.split('/').filter(Boolean);
}
